import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const GROUP_PATH = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7V5c0-1.1.9-2 2-2h2"/><path d="M17 3h2c1.1 0 2 .9 2 2v2"/><path d="M21 17v2c0 1.1-.9 2-2 2h-2"/><path d="M7 21H5c-1.1 0-2-.9-2-2v-2"/><rect width="7" height="5" x="7" y="7" rx="1"/><rect width="7" height="5" x="10" y="12" rx="1"/></svg>`;
const UNGROUP_PATH = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="6" x="5" y="4" rx="1"/><rect width="8" height="6" x="11" y="14" rx="1"/></svg>`;

export class GroupingControl {
  private _map: mapboxgl.Map | undefined;
  private _container!: HTMLElement;
  private isClicked: boolean = false;
  private translate = inject(TranslateService);
  private button!: HTMLElement;

  constructor(
    private readonly callback: (grouping: boolean) => void,
    private readonly isCurrentlyFiltering: () => boolean
  ) {}

  onAdd(map: mapboxgl.Map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

    this.button = document.createElement('button');
    this.button.className = 'mapboxgl-ctrl-icon';
    this.button.innerHTML = UNGROUP_PATH;
    this.button.style.padding = '3px';
    this.button.title = this.translate.instant('map.controls.ungroup');
    this.button.onclick = () => this.onClick();

    this._container.appendChild(this.button);

    return this._container;
  }

  onRemove() {
    this._container.parentNode!.removeChild(this._container);
    this._map = undefined;
  }

  reset() {
    this.isClicked = false;
    this.button.innerHTML = UNGROUP_PATH;
  }

  private onClick() {
    if (this.isCurrentlyFiltering()) return;

    this.isClicked = !this.isClicked;
    if (this.isClicked) {
      this.button.innerHTML = GROUP_PATH;
      this.callback(false);
      this.button.title = this.translate.instant('map.controls.group');
      return;
    }
    this.button.title = this.translate.instant('map.controls.ungroup');
    this.callback(true);
    this.button.innerHTML = UNGROUP_PATH;
  }
}
